import { AfterViewInit, Component, inject, input, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatSort, MatSortModule } from '@angular/material/sort';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTableDataSource,
  MatTableModule
} from '@angular/material/table';

import { Subscription } from 'rxjs';
import { AuditAnnouncementLog } from 'src/app/models/audit/auditAnnoucementlog';
import { AuditAnnouncementService } from 'src/app/services/audit-annoucement.service';

@Component({
  selector: 'app-audit-announcements',
  templateUrl: './audit-announcements.component.html',
  styleUrls: ['./audit-announcements.component.scss'],
  imports: [
    MatCardModule,
    MatTableModule,
    MatSortModule,
    MatSortModule,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow
  ]
})
export class AuditAnnouncementsComponent implements OnInit, AfterViewInit, OnDestroy {
  readonly auditId = input.required<string>();
  announcementService = inject(AuditAnnouncementService);

  // TODO: Skipped for migration because:
  //  There are references to this query that cannot be migrated automatically.
  @ViewChildren('announcTableComp', { read: MatSort }) announceSort!: QueryList<MatSort>;

  subs: Subscription[] = [];
  loaded = false;

  announceTable = {
    ready: false,
    data: new MatTableDataSource<AuditAnnouncementLog>(),
    col: [
      { title: 'to', field: 'sentTo', custom: 'name' },
      { title: 'on', field: 'sentOn' },
      { title: 'by', field: 'sentBy', custom: 'name' }
    ]
  };

  ngOnInit() {
    this.loadAnnouncements();
  }

  loadAnnouncements(): void {
    this.announcementService.getDataById(this.auditId()).subscribe({
      next: (announcements) => {
        this.announceTable.data.data = announcements;
      }
    });
  }

  ngAfterViewInit() {
    this.subs.push(
      this.announceSort.changes.subscribe({
        next: (data) => {
          if (data.length) {
            this.announceTable.data.sort = data.toArray()[0];
          }
        }
      })
    );
  }

  ngOnDestroy() {
    this.subs.forEach((v) => v.unsubscribe());
  }

  colFields(col: { field: string }[]) {
    return col.map((v) => v.field);
  }
}
